var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('user-select',{attrs:{"show":_vm.showPltSelect,"users":_vm.user,"orgId":_vm.orgId,"multiEnable":_vm.multiEnable},on:{"update:show":function($event){_vm.showPltSelect=$event},"user-checked":_vm.selectModalEvt}})}
var staticRenderFns = []

export { render, staticRenderFns }